export default [
{
    path: "/xh",
    name: "_xh",
    component: () => import("../views/XH/index"),
    children: [
        {
            path: "stepsdetail/:activity_id/:acid?",
            name: "xhdetail",
            props:(route)=>({
                activity_id:route.params.activity_id,
                acid:route.params.acid
            }),
            component: () => import( /* webpackChunkName: "Orient" */ "../views/XH/Detail/index.vue"),
            meta: {
                title: "线上运动会",
                showloading: true,
                requiresAuth: true,
                bgcolor: "#6691db"
            }
        },
        {
            path: "stepsdetail23/:activity_id/:acid?",
            name: "xhdetail23",
            props:(route)=>({
                activity_id:route.params.activity_id,
                acid:route.params.acid
            }),
            component: () => import( /* webpackChunkName: "Orient" */ "../views/XH/Detail2023/index.vue"),
            meta: {
                title: "线上运动会",
                showloading: true,
                requiresAuth: true,
                bgcolor: "#3BB8C6"
            }
        },
        {
            path: "stepsdetail24/:activity_id/:acid?",
            name: "xhdetail24",
            props:(route)=>({
                activity_id:route.params.activity_id,
                acid:route.params.acid
            }),
            component: () => import( /* webpackChunkName: "Orient" */ "../views/XH/Detail2024/index.vue"),
            meta: {
                title: "线上运动会",
                showloading: true,
                requiresAuth: true,
                bgcolor: "#01ABF9"
            }
        },
        {
            path: "stepsdetaily/:itemid/:acid?",
            name: "xhdetaily",
            props:(route)=>({
                itemid:route.params.itemid,
                acid:route.params.acid
            }),
            component: () => import( /* webpackChunkName: "Orient" */ "../views/XH/Detaily/index.vue"),
            meta: {
                title: "线上运动会",
                showloading: true,
                requiresAuth: true,
                bgcolor: "#3bb8c6"
            }
        },
        {
            path: "steps/:activity_id/:acid?",
            name: "xhsteps",
            props:(route)=>({
                activity_id:route.params.activity_id,
                acid:route.params.acid
            }),
            component: () => import( /* webpackChunkName: "Orient" */ "../views/XH/Steps/Detail.vue"),
            meta: {
                title: "“路”遇大明星",
                showloading: true,
                requiresAuth: true
            }
        },
        {
            path: "steps23/:activity_id/:acid?",
            name: "xhsteps23",
            props:(route)=>({
                activity_id:route.params.activity_id,
                acid:route.params.acid
            }),
            component: () => import( /* webpackChunkName: "Orient" */ "../views/XH/Steps2023/Detail.vue"),
            meta: {
                title: "运动空间大“上新”",
                showloading: true,
                requiresAuth: true
            }
        },
        {
            path: "sublist",
            name: "xhsublist",
            component: () => import( /* webpackChunkName: "Orient" */ "../views/XH/Sublist/index.vue"),
            meta: {
                title: "线上运动会",
                showloading: true,
                requiresAuth: true,
                bgcolor: "#6691DB"
            }
        },
        {
            path: "rank",
            name: "xhrank",
            component: () => import( /* webpackChunkName: "Orient" */ "../views/XH/Rank/index.vue"),
            meta: {
                title: "排行榜",
                showloading: true,
                requiresAuth: true,
                bgcolor: "#8674FC"
            }
        },
        {
            path: "rank23/:activity_id",
            name: "xhrank23",
            component: () => import( /* webpackChunkName: "Orient" */ "../views/XH/Rank2023/index.vue"),
            meta: {
                title: "排行榜",
                showloading: true,
                requiresAuth: true,
                bgcolor: "#3BB8C6"
            }
        },
        {
            path: "rank25/:cpgid",
            name: "xhrank25",
            component: () => import( /* webpackChunkName: "Orient" */ "../views/XH/Rank25/index.vue"),
            meta: {
                title: "排行榜",
                showloading: true,
                requiresAuth: true
            }
        },
        {
            path: "share/:groupid/:activity_id/:acid?",
            name: "share",
            component: () => import( /* webpackChunkName: "Orient" */ "../views/XH/Share/index.vue"),
            meta: {
                title: "排行榜",
                showloading: true,
                requiresAuth: true,
                bgcolor: "#3BB8C6"
            }
        },
        {
            path: "aisports",
            name: "aisports",
            component: () => import(/* webpackChunkName: "exchange" */"../views/XH/Home/index.vue"),
            meta: {
                title: "线上运动会",
                showloading: false,
                requiresAuth: true
            }
        },
        {
            path: "task/:taskid/:sportsid",
            name: "task",
            component: () => import(/* webpackChunkName: "exchange" */"../views/XH/Task/index.vue"),
            meta: {
                title: "训练计划",
                showloading: false,
                requiresAuth: true
            }
        },
        {
            path: "taskinfo/:taskid/:sports_id/:item_sub_id",
            name: "taskinfo",
            props:true,
            component: () => import(/* webpackChunkName: "exchange" */"../views/XH/Taskinfo/Index.vue"),
            meta: {
                title: "活动详情",
                showloading: false,
                requiresAuth: true
            }
        },
        {
            path: "xhjoin/:item_sub_id/:sports_id/:signtype/:taskid?",
            name: "xhjoin",
            props:true,
            component: () => import(/* webpackChunkName: "home" */"../views/XH/Register/Index.vue"),
            meta: {
                requiresAuth: true,
                showloading: false,
                title:"报名"
            }
        },
    ]
}
]